import { AcLockObject } from '@opp/ui-kit';

export const KEYS = AcLockObject({
  ACCESS_TOKEN: 'access_token',
  ACCOUNT: 'account',
  ACTIVE: 'Active',
  ASCENDING: 'asc',
  BACKGROUND_COVER: 'bgc',
  BALANCE: 'balance',
  BANK: 'bank',
  BANKS: 'banks',
  BANK_ACCOUNT: 'bank_account',
  BANK_ACCOUNTS: 'bank_accounts',
  BANK_REPORT: 'bank_report',
  BANK_REPORTS: 'bank_reports',
  BAR: 'bar',
  BODY: 'body',
  BREADCRUMBS: 'breadcrumbs',
  CHANGELOG: 'changelog',
  CHILDREN: 'children',
  CLOSEABLE: 'closeable',
  COLLECTION: 'collection',
  CONFIRM: 'confirm',
  CONFIRM_PASSWORD: 'confirm-password',
  CONTEXTUAL_MENU: 'contextual_menu',
  COUNTS: 'counts',
  CURRENT_MONTH: 'current_month',
  CURRENT_NAVIGATION: 'current_navigation',
  CURRENT_QUARTER: 'current_quarter',
  CURRENT_WEEK: 'current_week',
  DEB: 'deb',
  DEFAULT: 'default',
  DESCENDING: 'desc',
  DRAWER: 'drawer',
  DURATION: 'duration',
  EMAIL: 'email',
  ERROR: 'error',
  EVENTS: 'events',
  EXPANDED: 'expanded',
  EXPIRES_AT: 'expires_at',
  EXPIRES_IN: 'expires_in',
  ID: 'id',
  INCOMING: 'incoming',
  ITEM: 'item',
  ITEMS: 'items',
  LAST_7_DAYS: 'last_7_days',
  LAST_15_DAYS: 'last_15_days',
  LAST_30_DAYS: 'last_30_days',
  LAST_90_DAYS: 'last_90_days',
  LIST: 'list',
  LOADED: 'loaded',
  LOCALE: 'locale',
  MAP: 'map',
  MESSAGE_CENTER: 'message_center',
  MINMAX: 'minmax',
  MODAL: 'modal',
  MULTI_SELECT: 'multi_select',
  NAME: 'name',
  NAVIGATION: 'navigation',
  NEXT: 'next',
  NOTIFICATIONS: 'notifications',
  OBJECT: 'object',
  OBJECT_NO: 'object_no',
  OPTIONS: 'options',
  OTHER: 'other',
  OUTGOING: 'outgoing',
  PASSWORD: 'password',
  PREVIOUS: 'previous',
  PREVIOUS_QUARTER: 'previous_quarter',
  PREVIOUS_MONTH: 'previous_month',
  PREVIOUS_WEEK: 'previous_week',
  PROFILE: 'profile',
  PROGRESS: 'progress',
  REFRESH_TOKEN: 'refresh_token',
  ROLE: 'role',
  ROLES: 'roles',
  SCROLLER: 'ac-scroller',
  SETTLEMENTS: 'settlements',
  SETTLEMENT: 'settlement',
  SUB_NAVIGATION: 'sub_navigation',
  SUPPORT_CENTER: 'support_center',
  SUPPORT_EMAIL_ADDRESS: 'support@onlinepaymentplatform.com',
  TABLE_CONTEXTUAL_MENU: 'table_contextual_menu',
  TICKETS: 'tickets',
  TIME: 'time',
  TIMING: 'timing',
  TITLE: 'title',
  TODAY: 'today',
  TOKEN_TYPE: 'token_type',
  TRANSACTIONS: 'transactions',
  TRANSACTION: 'transaction',
  TRACKING: 'tracking',
  UID: 'uid',
  USER: 'user',
  USERS: 'users',
  USER_MENU: 'user_menu',
  VISIBLE: 'visible',
  XUSR_TOKEN: 'xusr_token',
  YESTERDAY: 'yesterday',
  COMPLIANCE_REQUIREMENTS: 'compliance_requirements',
  SETTINGS: 'settings',
  REFUNDABLE: 'refundable',
  NOT_REFUNDABLE_REASON_OTHER: 'other',
  NOT_REFUNDABLE_REASON_STATUS: 'status',
  NOT_REFUNDABLE_REASON_ALREADY_REFUNDED: 'already-refunded',
});

export default KEYS;
